import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';
import AgencyBrandThemeMode from './AgencyBrandThemeMode';

export default class UpdateAgencyProfileDetailsRequest extends BaseUpdateRequest {
	brandName: string;  
	brandPrimaryColour: string;
    brandThemeMode: AgencyBrandThemeMode;
	website: string;     			
	biography: string;          						
}